
import { MapTo } from '@adobe/aem-react-editable-components';
import MobileWalletSetup, { MobileWalletSetupEditConfig } from './MobileWalletSetup';

export default MapTo('cob-corp-acquisition/components/creditonebank/mobile-wallet-setup')(MobileWalletSetup, MobileWalletSetupEditConfig);
        